import { supabase } from '@/lib/supabase';
import { clearInventoryCache } from './inventory';
import { createTransactionRunner } from '../inventoryTransactionRunner';

export const runInventoryTransaction = createTransactionRunner({
  rpc: (name, params) => supabase.rpc(name, params),
  getActor: async () => {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    if (!data.session) throw new Error('No hay sesión activa');
    return data.session.user.id;
  },
  storage: typeof sessionStorage === 'undefined' ? null : sessionStorage,
  onSuccess: clearInventoryCache,
});
